import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger)

export const statistics = () => {
	translateCharacters()
	// tickerNumbers()
}

const translateCharacters = () => {

	let els = document.querySelectorAll('[data-animation="characters"]')

	if (!els.length) return

	document.fonts.ready.then(() => {
		els.forEach(el => {

			el.style.opacity = 1

			let split = new SplitText(el, { type: 'lines, chars', linesClass: 'line', wordsClass: 'char' })

			el.removeAttribute('aria-label')

			gsap.fromTo(split.chars, {
				y: '115%',
				opacity: 1,
				rotate: "4deg",
			}, {
				y: 0,
				opacity: 1,
				rotate: "0deg",
				stagger: 0.1,
				duration: 1.2,
				ease: 'power2.out',
				scrollTrigger: {
					trigger: el,
					start: 'top 85%',
					// markers: true,
				}
			})
		})
	})
}

const tickerNumbers = () => {

	let els = document.querySelectorAll('[data-animation="statistic"]')

	if (!els.length) return

	els.forEach(el => {

		let digits = el.querySelectorAll('.digit')

		digits.forEach(digit => {

			let from = parseInt(digit.getAttribute('data-from'), 10),
				to = parseInt(digit.textContent, 10)

			digit.textContent = ''

			let original = document.createElement('span')

			original.textContent = to
			original.classList.add('original-digit')
			digit.appendChild(original)

			let inner = document.createElement('div')

			inner.classList.add('digit-wrapper')

			for (let i = to; i >= from; i--) {
				const span = document.createElement('span')
				span.textContent = i
				span.classList.add('digit')
				inner.appendChild(span)
			}

			digit.appendChild(inner)

			let digitHeight = inner.children[0].offsetHeight,
				totalDigits = inner.children.length,
				moveDistance = (totalDigits - 1) * digitHeight

			gsap.fromTo(inner, {
				y: 0
			}, {
				y: -moveDistance,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top bottom",
					end: "center center",
					scrub: true,
					// markers: true,
				}
			})

		})
	})
}

export default () => { }